module.exports = __webpack_public_path__ + "static/14-1c4b2489288a9b3a13cd1ed2bb803a4f.jpg";